import React from "react";
import AsyncSelect from "react-select/async";
import AsyncCreatableSelect from "react-select/async-creatable";
import { components } from "react-select";
import { IAsyncSelectProps } from "../../../interfaces/Index";
import "./AsyncSelect.scss";

export const SingleValue = (props: any) => {
  return (
    <components.SingleValue {...props}>
      {props.selectProps.placeholder}
    </components.SingleValue>
  );
};

const AsyncSelectComponent = (props: IAsyncSelectProps) => {
  return props.isCreatable ? (
    <AsyncCreatableSelect
      id={props.id}
      name={props.name}
      placeholder={props.placeHolderText}
      defaultOptions={props.defaultAsyncOptions}
      removeSelected={false}
      hideSelectedOptions={false}
      loadOptions={props.loadAsyncOptions}
      onChange={(e, action) => props.handleAsyncSelectChange(e, action)}
      inputProps={{ maxLength: 5 }}
      styles={props.styles}
      components={props.isCustomSelectValue ? { SingleValue } : undefined}
      isDisabled={props.isDisabled}
    />
  ) : (
    <AsyncSelect
      id={props.id}
      name={props.name}
      placeholder={props.placeHolderText}
      defaultOptions={props.defaultAsyncOptions}
      removeSelected={false}
      hideSelectedOptions={false}
      loadOptions={props.loadAsyncOptions}
      onChange={(e, action) => props.handleAsyncSelectChange(e, action)}
      inputProps={{ maxLength: 5 }}
      styles={props.styles}
      components={props.isCustomSelectValue ? { SingleValue } : undefined}
      isDisabled={props.isDisabled}
    />
  );
};

export const customAsynSelectStyles = {
  indicatorSeparator: (provided: any) => ({
    ...provided,
    display: "none",
  }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    display: "none",
  }),
  placeholder: () => ({
    fontSize: "14px",
    color: "#69767B",
    padding: "3px 0px 0px 3px",
    position: "absolute",
  }),
  control: () => ({
    boxShadow: "none",
    border: "1px solid #c8d4d9",
    color: "#69767b",
    borderRadius: "40px",
    height: "40px",
  }),
  menu: (provided: any) => ({
    ...provided,
    marginTop: "3px !important",
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: "#69767B",
  }),
};

AsyncSelectComponent.defaultProps = {
  defaultAsyncOptions: [],
  styles: customAsynSelectStyles,
  isDisabled: false,
  isCreatable: false,
  name: "",
};

export default AsyncSelectComponent;
